module.exports = function() {

    /**
     * Buttons && Modals
     */
    var $addEmploymentHistoryForGuardianButton = $('#js-add-employment-history-guardian'),
        $addEmploymentHistoryForGuardianModal = $('#add-employment-history-guardian');

    /**
     * Controllers
     */
    var AddEmploymentHistoryForGuardianController = new (require('./AddEmploymentHistoryController'))($addEmploymentHistoryForGuardianModal);

    // Lets show modal on button click
    $addEmploymentHistoryForGuardianButton.click(function(e){
        AddEmploymentHistoryForGuardianController.showModal();
        e.preventDefault();
    });
}();
